import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
import 'firebase/functions'
import 'firebase/analytics'

const config = {
    apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
    authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
    databaseURL: process.env.VUE_APP_FIREBASE_DATABASE_URL,
    projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
	messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGE_SENDER_ID,
	appId: process.env.VUE_APP_FIREBASE_APP_ID,
	measurementId: undefined
}

const measurementId = process.env.VUE_APP_FIREBASE_MEASUREMENT_ID
if (measurementId)
{
	config.measurementId = measurementId
}

firebase.initializeApp(config)

const auth = firebase.auth()
const firestore = firebase.firestore()
const functions = firebase.functions()
const analytics = config.measurementId ? firebase.analytics() : undefined

const Timestamp = firebase.firestore.Timestamp

export {
	firebase,
	auth,
	firestore,
	functions,
	analytics,

	Timestamp
}
